import $ from 'jquery';

const toggle = document.querySelector( '.product-descriptionToggle' );
const description = document.querySelector( '.product-description' );

function handleToggle() {
	$( description ).slideToggle();
	toggle.classList.toggle( 'is-open' );
	toggle.querySelector( 'span' ).innerHTML = toggle.classList.contains( 'is-open' ) ? 'Less Info' : 'More Info';
}

function initEvents() {
	toggle.addEventListener( 'click', handleToggle );
}

function init() {
	if ( !toggle ) {
		return;
	}

	initEvents();
}

export default {
	init,
};
